export const defaultPayload = (result: { payload }): any => result.payload;
